import { useEffect } from 'react';

// Store the initial version when the app loads
let currentVersion: number | null = null;

export function useAutoUpdate() {
  useEffect(() => {
    const checkForUpdate = async () => {
      try {
        // Bypass cache by appending a timestamp query parameter
        const res = await fetch(`/version.json?t=${Date.now()}`);
        if (!res.ok) return;
        const data = await res.json();
        
        if (currentVersion === null) {
          // First load, save the version to memory
          currentVersion = data.version;
        } else if (data.version !== currentVersion) {
          // A new version was deployed! 
          console.log("New version detected! Purging caches and auto-reloading...");
          
          // 1. Unregister all Service Workers to drop PWA caching
          if ('serviceWorker' in navigator) {
            const registrations = await navigator.serviceWorker.getRegistrations();
            for (let reg of registrations) {
              await reg.unregister();
            }
          }

          // 2. Clear all local Cache Storage (used by SW)
          if ('caches' in window) {
            const cacheNames = await caches.keys();
            for (let name of cacheNames) {
              await caches.delete(name);
            }
          }

          // 3. Force reload the page (now acting as a true Hard Refresh)
          window.location.reload();
        }
      } catch (err) {
        // Ignore fetch errors (e.g., user is offline)
      }
    };

    // Check immediately on initial mount
    checkForUpdate();

    // Check every 5 minutes silently in the background
    const interval = setInterval(checkForUpdate, 5 * 60 * 1000);

    // Check whenever the user brings the browser tab back into focus
    window.addEventListener('focus', checkForUpdate);

    return () => {
      clearInterval(interval);
      window.removeEventListener('focus', checkForUpdate);
    };
  }, []);
}
